import { useState } from 'react';

export default () => {
  // 使用 useState 来管理一个 Map 数据结构，命名为 recommend
  const [recommend, setRecommend] = useState(new Map());

  // 添加一个推荐项的函数
  const addRecommend = (id: string, key: string, value: any) => {
    setRecommend(prevRecommend => {
      const newRecommend = new Map(prevRecommend);
      // 如果 id 已存在，更新对应的项
      if (newRecommend.has(id)) {
        const item = newRecommend.get(id);
        item[key] = value; // 更新对应的 key
      } else {
        newRecommend.set(id, { [key]: value }); // 新增项
      }
      return newRecommend;
    });
  };

  // 获取推荐项的函数
  const getRecommend = (id: string) => {
    return recommend.get(id);
  };
  // 增加一个更新指定detail里的指定key的函数，如果 id 不存在，直接在控制台打印错误即可
  // 更新指定id下detail中的指定key
  const updateRecommendDetail = (id: string, detailKey: string, value: any) => {
    setRecommend(prevRecommend => {
      // 检查id是否存在
      if (!prevRecommend.has(id)) {
        console.warn(`Error: Recommend with id ${id} does not exist`);
        return prevRecommend;
      }

      const newRecommend = new Map(prevRecommend);
      const item = newRecommend.get(id);

      // 确保detail对象存在，如果不存在则创建
      if (!item.detail) {
        item.detail = {};
      }

      // 更新detail中的指定key
      item.detail[detailKey] = value;
      newRecommend.set(id, item);

      return newRecommend;
    });
  };
  // 合并更新detail对象（使用...覆盖）
  const mergeRecommendDetail = (id: string, newDetails: Record<string, any>) => {
    setRecommend(prevRecommend => {
      // 检查id是否存在
      if (!prevRecommend.has(id)) {
        console.warn(`Error: Recommend with id ${id} does not exist`);
        return prevRecommend;
      }

      const newRecommend = new Map(prevRecommend);
      const item = newRecommend.get(id);

      // 使用扩展运算符合并新旧detail，新内容会覆盖旧内容，但不会删除未提及的属性
      item.detail = {
        ...(item.detail || {}), // 保留现有detail内容
        ...newDetails // 合并新内容，相同key会被覆盖
      };

      newRecommend.set(id, item);
      return newRecommend;
    });
  };
  return {
    addRecommend,
    getRecommend,
    updateRecommendDetail,
    mergeRecommendDetail
  }
}
